// Guard optional widgets so the collection script can run safely after Shopify partial renders.
function initGamingChairsPage() {
    var typingNode = document.querySelector("#b5-typing_words");
    var materialsSelectors = document.querySelector(".b5-materials-selectors-wrap");
    var compareProductsList = document.querySelector(".b5-compare-products-lists");
    var featuredShareGallery = document.getElementById("b5-featured-share--lightGallery");
    var pressReviewsList = document.querySelector(".press-reviews__list");
    var hasSlick = typeof $ !== "undefined" && $.fn && $.fn.slick;

    if (typingNode && typeof Typed !== "undefined") {
        var typingWords = (typingNode.dataset.words || "").split(",");
        if (typingWords.length > 1) {
            typingNode.innerHTML = "";
            for (var i = 0; i < typingWords.length; i++) {
                typingWords[i] += " ^2000";
            }
            new Typed("#b5-typing_words", {
                strings: typingWords,
                typeSpeed: 40,
                backSpeed: 0,
                loop: true,
                showCursor: false,
                smartBackspace: false,
            });
        }
    }

    if (
        hasSlick &&
        compareProductsList &&
        window.Boulies &&
        Boulies.setting &&
        Boulies.setting.screenSize === "large" &&
        !$(compareProductsList).hasClass("slick-initialized")
    ) {
        $(compareProductsList).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="slick-prev"></div>',
            nextArrow: '<div class="slick-next"></div>',
            infinite: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: "unslick",
                },
            ],
        });
    }

    if (typeof lightGallery === "function" && featuredShareGallery) {
        lightGallery(featuredShareGallery, {
            licenseKey: "DA7E83CA-6E474542-97592C9F-8A8DFF9D",
            download: false,
            plugins: [lgZoom],
        });
    }

    if (materialsSelectors) {
        materialsSelectors.addEventListener("mouseover", function (e) {
            var _target = e.target.closest(".b5-material-button");
            if (!_target) return;
            document.querySelectorAll(".b5-material-button").forEach(function (v) {
                v.dataset.status = "";
            });
            _target.dataset.status = "is_actived";
            document.querySelectorAll(".b5-intro-description--material").forEach(function (v) {
                if (v.dataset.tab == _target.dataset.tab) {
                    v.dataset.status = "is_actived";
                } else {
                    v.dataset.status = "";
                }
            });
            document.querySelectorAll(".b5-material-image").forEach(function (v) {
                if (v.dataset.tab == _target.dataset.tab) {
                    v.dataset.status = "is_actived";
                } else {
                    v.dataset.status = "";
                }
            });
        });
    }

    if (compareProductsList) {
        compareProductsList.addEventListener("click", function (e) {
            var _target = e.target.closest(".b5-view-variants-btn");
            if (!_target) return;
            document.querySelectorAll(".b5-view-variants-btn").forEach(function (v) {
                v.dataset.status = "";
            });
            _target.dataset.status = "is_actived";
            document.querySelectorAll(".b5-collection-product").forEach(function (v) {
                if (v.dataset.series !== _target.dataset.series) {
                    v.style.display = "none";
                } else {
                    v.style.display = "block";
                }
            });
        });
    }

    if (hasSlick && pressReviewsList && !$(pressReviewsList).hasClass("slick-initialized")) {
        $(pressReviewsList).slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 650,
                    settings: {
                        dots: true,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGamingChairsPage);
} else {
    initGamingChairsPage();
}
